import { isLocalhost } from "../utils";
import { XNotifications, XNotificationsProps } from "./notification";

export function XGame({
  notificationsProps,
  children,
  useGame,
}: {
  notificationsProps?: XNotificationsProps;
  children: React.ReactElement;
  useGame: () => { game: unknown; deleteGame: () => void };
}) {
  const { game, deleteGame } = useGame();
  console.info("XGame", game);

  return (
    <>
      {isLocalhost() && (
        <button
          style={{ position: "absolute", bottom: 0, right: 0, zIndex: 1000 }}
          onClick={async () => {
            await deleteGame();
            window.location.reload();
          }}
        >
          reset
        </button>
      )}
      <XNotifications {...notificationsProps} />
      {children}
    </>
  );
}
